export default {
  requiredField: "Campo obligatorio",
  requiredSelect: "Selecciona una opción",
  requiredCheck: "Selección obligatoria",
  passwordMatch:
    "Tu contraseña debe contener de 8 a 12 dígitos, con una combinación de letras y números",
  mismatchedPass: "Las contraseñas no coinciden",
  charMessage: "Solo se permiten letras",
  invalidName: "Ingresa tu nombre completo por favor",
  invalidNameChild: "Ingresa el nombre completo de tu hijo, por favor.",
  invalidMail: "Correo electrónico no válido",
  mismatchedMail: "El correo electrónico ingresado no coincide",
  invalidPhone: "Número no válido",
  invalidDate: "Fecha no válida",
  legallyYounger: "Solo mayores de 18 años",
  legallyOlder: "Solo menores de 18 años",
  invalidCPF: "CPF inválido",
  genericError: "Ha ocurrido un error. Por favor intente otra vez",
};
